import React, { useEffect, useRef } from "react";
import "./Packaging.css";
import emailjs from '@emailjs/browser';



const Packaging = () => {
    const bannerRef = useRef(null);

useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) bannerRef.current.classList.add("visible");
            },
            { threshold: 0.3 }
        );
        if (bannerRef.current) observer.observe(bannerRef.current);
    }, []);

    return (
        <section className="packaging">
            {/* === SECCIÓN 1: Banner con animación === */}
            <div className="packaging-banner" ref={bannerRef}>
                <img src="/images/packaging/cajas-banner.png" alt="espectacular" className="packaging-espectacular" />
                <div className="packaging-banner-texto">
                    <h3>Packaging <br></br>de lujo</h3>
                    <img src="/images/logo/MotiPuntos.svg" style={{ height: '0.7rem' }}></img>
                    <p className="p-packaging">Innovación en cada solución</p>
                </div>
            </div>

            {/* === SECCIÓN 2: Texto + Imagen edificio === */}
            <div className="packaging-info">
                <p className="packaging-subtitle">we make it <span>happen.</span></p>

                <div className="packaging-info-contenido">
                    <div className="packaging-info-texto">
                        <div className="packaging-tag"> <img src="/images/packaging/caja-tag.svg" style={{ height: '1rem' }}></img> Empaque de lujo</div>
                        <h2>
                            Piensa fuera de la caja con nuestros<br></br>
                            <span> empaques de lujo</span>
                        </h2>
                        <p>
                            Con nuestros materiales, diseños personalizados y acabados de lujo, <b> las posibilidades son infinitas. </b>
                            Creamos empaques que transforman el "unboxing" en una experiencia visual memorable.
                        </p>
                        <p className="packaging-cta">
                            En Moti Digital lo hacemos posible, <a href="#cotiza">solicita tu cotización:</a>
                        </p>
                        <div className="packaging-input-wrapper">
                           
                           <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const form = e.target;
                                    const button = form.querySelector("button");
                                    const input = form.querySelector("input");

                                    button.disabled = true;
                                    const originalText = button.textContent;
                                    button.textContent = "Enviando...";

                                    try {
                                        const serviceID = "service_lxg5sht";
                                        const templateID = "template_epehkcc";
                                        const publicKey = "4f0iRLKGvmXsd0ASA";

                                        const params = {
                                            from_name: input.value,
                                            message: `Me interesan sus productos de Packaging de lujo. Me pueden contactar al correo ${input.value}, me estoy contactando desde motidigital.com `,
                                        };

                                        console.log("📤 Enviando con EmailJS...");
                                        console.log({ serviceID, templateID, publicKey, params });

                                        const res = await emailjs.send(serviceID, templateID, params, publicKey);
                                        console.log("✅ Respuesta EmailJS:", res);

                                        if (res.status === 200) {
                                            button.textContent = "Enviado ✔";
                                            input.value = "";
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                                button.disabled = false;
                                            }, 3000);
                                        } else {
                                            throw new Error("Error en el envío");
                                        }
                                    } catch (error) {
                                        console.error("❌ Error al enviar con EmailJS:", error);

                                        button.textContent = "Error ✖";
                                        setTimeout(() => {
                                            button.textContent = originalText;
                                            button.disabled = false;
                                        }, 2500);
                                    }
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                />
                                <button type="submit">Empecemos</button>
                            </form>
                        </div>
                    </div>

                    <div className="packaging-info-imagen">
                        <img src="/images/packaging/caja.png" alt="Packaging en edificio" />
                    </div>
                </div>
            </div>
            <div className="packaging-final">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="packaging-dots" />
                <h2>
                    ¿Listo para hacer crecer <br />
                    <span>tu empresa?</span>
                </h2>

                {/* Doble marquee - VERSIÓN SIMPLE */}
                <div className="packaging-marquees">
                    <div className="packaging-marquee packaging-line1">
                        <span>
                            IFABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                        </span>
                        <span>
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                        </span>
                    </div>

                    <div className="packaging-marquee packaging-line2">
                        <span>
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                        </span>
                        <span>
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                            EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO · EMPAQUES DE LUJO ·
                        </span>
                    </div>
                </div>


                {/* Slider semicircular */}
                <div className="packaging-slider">
                    <div className="packaging-slider-track">
                        <img src="/images/packaging/slider/1.png" alt="img1" />
                        <img src="/images/packaging/slider/2.png" alt="img2" />
                        <img src="/images/packaging/slider/3.png" alt="img3" />
                        <img src="/images/packaging/slider/4.png" alt="img4" />
                        <img src="/images/packaging/slider/5.png" alt="img5" />
                    </div>
                </div>
            </div>
            {/* === SECCIÓN 3: Opción estratégica === */}
            <div className="packaging-opcion">
                <img src="/images/logo/Moti Logo.svg" alt="decorativo" className="packaging-opcion-icon" />

                <div className="packaging-opcion-card">
                    <div className="packaging-opcion-left">
                        <h2>Conoce nuestros <br></br> acabados</h2>
                        <p>Innovación y calidad<br></br>en cada material</p>
                        <button className="packaging-btn-cotizar">Cotizar ahora</button>
                    </div>

                    <div className="packaging-opcion-right">
                        <div className="packaging-opcion-item">
                            <div className="packaging-icon" style={{ backgroundColor: "#f7c19a" }}>
                                <img src="/images/packaging/foil.svg" alt="Variedad" />
                            </div>
                            <div>
                                <h4>Foil</h4>
                                <p>• Crea un acabado táctil elevado y texturizado sobre la superficie del material.<br></br> <br></br>
                                    • Proporciona un efecto brillante y sutil en elementos específicos, como logotipos o textos importantes.</p>
                            </div>
                        </div>

                        <div className="packaging-opcion-item">
                            <div className="packaging-icon" style={{ backgroundColor: "#c9e7e4" }}>
                                <img src="/images/packaging/barniz.svg" alt="Personalización" />
                            </div>
                            <div>
                                <h4>Barniz</h4>
                                <p>•Acabado plano y metálico que ofrece un efecto visual brillante.<br></br> <br></br>
                                    • Perfecto para crear detalles llamativos como acentos decorativos en plata, dorado,cobre, y otros colores metálicos</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="packaging-faq">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="packaging-dots" />
                <h2>Preguntas frecuentes</h2>
                <div className="packaging-faq-contenedor">
                    {/* Lado izquierdo - Acordeón */}
                    <div className="packaging-faq-lista">
                        <details open>
                            <summary>¿Tienen un pedido mínimo?</summary>
                            <p>
                                El pedido mínimo varía según el tipo de empaque y personalización requerida. 
                                Contáctanos para una cotización específica de tu proyecto.

                            </p>
                        </details>

                        <details>
                            <summary>¿Entre qué acabados puedo elegir?</summary>
                            <p>
                                Ofrecemos una amplia gama de acabados: barniz UV selectivo, 
                                laminado mate o brillante, stamping foil en dorado/plateado, relieves, 
                                troqueles especiales, ventanas de acetato, y acabados texturizados. 
                                Cada acabado se adapta a las necesidades específicas de tu marca.
                            </p>
                        </details>

                        <details>
                            <summary>¿Ofrecen servicios de diseño?</summary>
                            <p>
                                Sí, contamos con un equipo de diseñadores especializados en packaging que pueden crear conceptos desde cero u optimizar tus archivos existentes. 
                                Desarrollamos diseños que no solo son visualmente atractivos, 
                                sino también funcionales y optimizados para producción.
                            </p>
                        </details>

                        <details>
                            <summary>¿Puedo personalizar mis diseños?</summary>
                            <p>
                                ¡Absolutamente! La personalización es nuestra especialidad. 
                                Trabajamos con formas únicas, ventanas, cierres especiales y cualquier elemento que haga que tu packaging se destaque. 
                                Desde empaques simples hasta estructuras complejas, lo hacemos posible.
                            </p>
                        </details>

                        <details>
                            <summary>¿Cuáles son los materiales disponibles para mis productos?</summary>
                            <p>
                                Trabajamos con cartón corrugado, cartulina kraft, cartón duplex, microcorrugado, PET, PVC, acetato, y muchos más. 
                                Cada material se selecciona según las necesidades de protección, estética y sustentabilidad de tu producto.
                            </p>
                        </details>
                    </div>

                    {/* Lado derecho - Contacto */}
                    <div className="packaging-faq-contacto">
                        <h3>¿Tienes más dudas?</h3>
                        <p>No dudes en contactarnos para más información.</p>

                        <div className="packaging-contacto-email">
                            <div className="packaging-email-box">
                                <img src="/images/packaging/mail.svg" alt="email" />
                                <span>COTIZACIONES@MOTIDIGITAL.COM</span>
                                <button>Agendar una llamada</button>
                            </div>
                            <button className="packaging-btn-whatsapp"> Cotiza tu proyecto</button>
                        </div>

                        <div className="packaging-faq-img">
                            <img src="/images/granformato/faq-banner.png" alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>

        </section>

    );
};

export default Packaging;